import React from "react";
import styled from "styled-components";
import { Typography } from "ui-kit/Typography";
import BackArrow from "assets/back-arrow.svg";
import ThemeStore from "stories/ThemeStore";
import {FormattedMessage} from "react-intl";

interface HeaderProps {
  title: React.ReactNode;
  breadcrumbsText?: React.ReactNode;
  onBack?: () => void;
  setSingleTrack?: (value: boolean) => void;
  singleTrack?: boolean;
}

export const Header: React.FC<HeaderProps> = props => {
  const { title, breadcrumbsText, onBack, setSingleTrack, singleTrack } = props;
  const theme = ThemeStore.activeTheme;
  const params = new URLSearchParams(window.location.search);
  const stepParam = params.get('step');

  return (
    <BigBox>
      <Container>
        {!!breadcrumbsText && !!onBack && (
          <Breadcrumbs onClick={onBack}>
            <BackArrow color={theme.palette.text.breadcrumbs} />
            <BreadcrumbsText variant="body4" color={theme.palette.text.breadcrumbs}>{breadcrumbsText}</BreadcrumbsText>
          </Breadcrumbs>
        )}
        <Typography variant="subtitle2">{title}</Typography>

      </Container>

      {stepParam === "release-info" && <InputBox >
        <Checkbox
          type="checkbox"
          id="Single-track"
          checked={singleTrack}
          onChange={() => {
            if (setSingleTrack && typeof singleTrack === 'boolean') {
              setSingleTrack(!singleTrack);
            }
          }}
        />
        <label htmlFor="Single-track">
          <FormattedMessage
            id="NewRelease.Header.SingleTrack"
            defaultMessage="Single-track release"
          />
        </label>
      </InputBox>}
    </BigBox>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 26px;
`;

const Breadcrumbs = styled.div`
  display: flex;
  gap: 10px;
  cursor: pointer;
  width: fit-content;
`;

const BreadcrumbsText = styled(Typography)`
  font-weight: 400;
`

const Box = styled.div`
    display:flex;
    gap:5px;
    
`

const BigBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  /* Mobile: stack title and the "single-track release" checkbox vertically */
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 12px;
  }
`
const InputBox = styled.div`
  margin-top:35px;
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;

  @media (max-width: 768px) {
    margin-top: 0;
  }

  label {
    font-family: 'SF Pro Display', sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0;
    vertical-align: middle;
    cursor: pointer;

  }
`
const Checkbox = styled.input.attrs({ type: "checkbox" })`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #6777FF;
  appearance: none;
  cursor: pointer;
  position: relative;
  background-color: ${(props) => (props.checked ? "#6777FF" : "#fff")};

  &:checked::after {
    content: "";
    position: absolute;
    top: 2px;
    left: 6px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  `